import React from "react";
import { MdDeck } from "react-icons/md";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
const AmountButtons = ({ className, param , increase, decrease, amount }) => {

  const { isDisabled } = useSelector((state) => state.common);


  
  return (
    <div className="carts-buttons">
      { !isDisabled && <button type="button" className="amount-btn" onClick={decrease}>
        <div className="remove-btn">
          <FaMinus />
        </div>
      </button>}
      <h5 className={`amount mt-1 ${className}`}>{amount}</h5>
      {!isDisabled && <button type="button" className="amount-btn" onClick={increase}>
        <div className="remove-btn">
          <FaPlus />
        </div>
      </button>}
    </div>
  );
};

export default AmountButtons;
